// @flow

import * as React from 'react';
import TextField from '@mui/material/TextField';
import { DatePicker as DatePickerComponent } from '@mui/x-date-pickers/DatePicker';

function asDate(date?: Date | string | null): Date | null {
  const dato = date ? (typeof date === 'string' ? new Date(date) : date) : null;

  if (dato) {
    dato.setUTCHours(0);
    dato.setUTCMinutes(0);
  }

  return dato;
}

type Props = {|
  name: string,
  label: string,
  onChange: (mixed) => void,
  value?: string,
  defaultValue?: string,
  minDate?: mixed,
  maxDate?: mixed,
  autoOk?: boolean,
  fullWidth?: boolean,
  style?: { [string]: string | number },
  error?: mixed,
  helperText?: mixed,
  placeholder?: string,
  inputProps?: mixed,
  clearLabel?: string
|};

type State = {
  selectedDate: Date | null
};

export default class DatePicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedDate: asDate(props.value || props.defaultValue || null)
    };
  }

  handleChange = (date: Date | null) => {
    const ev = {
      target: {
        name: this.props.name,
        value: date,
        type: 'text'
      }
    };

    this.setState({ selectedDate: date });
    this.props.onChange(ev);
  };

  render() {
    const {
      style,
      onChange, // eslint-disable-line no-unused-vars
      name, // eslint-disable-line no-unused-vars
      defaultValue, // eslint-disable-line no-unused-vars
      value, // eslint-disable-line no-unused-vars
      error,
      helperText,
      fullWidth,
      inputProps,
      placeholder,
      autoOk, // eslint-disable-line no-unused-vars
      clearLabel, // eslint-disable-line no-unused-vars
      ...props
    } = this.props;

    const today = new Date();
    const minDate = asDate(this.props.minDate);
    const maxDate = asDate(this.props.maxDate);

    return (
      <DatePickerComponent
        {...props}
        minDate={minDate || undefined}
        maxDate={maxDate || undefined}
        disablePast={minDate && minDate > today ? false : true}
        disableMaskedInput
        inputFormat="do MMMM yyyy"
        value={asDate(this.props.value || this.state.selectedDate)}
        onChange={this.handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            error={Boolean(error)}
            helperText={error || helperText || params.helperText}
            placeholder={placeholder}
            style={{ marginBottom: 24, ...style }}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              ...params.inputProps,
              ...inputProps
            }}
          />
        )}
      />
    );
  }
}